import { render, staticRenderFns } from "./periodical.vue?vue&type=template&id=6671aa10&scoped=true"
import script from "./periodical.vue?vue&type=script&lang=js"
export * from "./periodical.vue?vue&type=script&lang=js"
import style0 from "./periodical.vue?vue&type=style&index=0&id=6671aa10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6671aa10",
  null
  
)

export default component.exports